module.exports = __webpack_public_path__ + "static/media/hotel-villa-antonio-orebic-triple-room-cover.5d2f6848.jpg";